<template>
  <div>
    <el-card>
      <el-form ref="form" :inline="true">
        <el-form-item label="分类">
          <el-select
            v-model="queryForm.type"
            placeholder="请选择分类"
            clearable
          >
            <el-option
              :label="item.value"
              :value="item.key"
              v-for="item in courseTypeData"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题">
          <el-input
            placeholder="请输入标题"
            v-model="queryForm.title"
          ></el-input>
        </el-form-item>

        <el-form-item label="时间">
          <el-date-picker
            type="datetimerange"
            v-model="times"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toQuery" icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item class="generate">
          <el-button type="primary" @click="toAdd"
            >添加课程</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :data="courseList"
        stripe
        class="table"
        ref="userTable.multipleSelection"
        header-cell-class-name="table-header"
        border
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="id"
          label="ID"
          width="55"
          align="center"
        ></el-table-column>
       
        <el-table-column label="分类" prop="type" align="center"></el-table-column>
        <el-table-column label="标题" prop="title" align="center"></el-table-column>
        <el-table-column label="缩略图" align="center">
          <template slot-scope="scope">
            <div class="thumb_box">
                <img :src="scope.row.thumb_url" alt="">
            </div>
           
          </template>
        </el-table-column>
        <el-table-column label="时间" align="center">
          <template slot-scope="scope">
            {{
                $moment(scope.row.create_time * 1000).format(
                  "YYYY-MM-DD HH:mm:ss"
                )
              }}
          </template>
        </el-table-column>
       
        <el-table-column label="操作" align="center" >
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              @click="editGoods(scope.row)"
              size="small"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="removeTask(scope.row.id)"
              size="small"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>

       <!-- 分页区域 -->
     <div class="pagination">
       <span></span>
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.page"
        :page-sizes="[3, 5, 8, 10]"
        :page-size="queryForm.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        algin:="center"
      ></el-pagination>
     </div>

      <!-- 添加课程 -->
      <el-dialog :title="addtitle" :visible.sync="addDialog" :center=true width="40%" @close="closed" :close-on-click-modal=false>
      <el-form :model="addForm"  ref="addForm">
        <el-form-item el-form-item label="分类" label-width="100px">
            <el-select
                v-model="addForm.type"
                placeholder="请选择分类"
                clearable
              >
                <el-option
                  :label="item.value"
                  :value="item.key"
                  v-for="item in courseTypeData"
                  :key="item.key"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item el-form-item label="标题" label-width="100px">
            <el-input
              type="text"
              v-model="addForm.title"
              placeholder="请输入标题"
            />
        </el-form-item>

        <el-form-item el-form-item label="缩略图" label-width="100px">
            <el-upload
              class="avatar-uploader"
              action="123"
              :show-file-list="false"
              accept="image/*"
              :before-upload="beforeThumbUpload"
            >
                <img
                  v-if="thumbSrc"
                  style="width: 100%"
                  :src="thumbSrc"
                  class="avatar"
                />
                <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
                style="margin-top: 85px;"
                ></i>
            </el-upload>
        </el-form-item>

        <el-form-item el-form-item label="视频" label-width="100px">
          <div v-if="addForm.video_url" class="video_box">
            <video
              :src="addForm.video_url"
              style="cursor: pointer;outline: none;"
              controls="controls" 
              ref="videoPlay"
            ></video>
          </div>
          <el-button type="primary" @click="selectvideo"
            >{{isAdd=='add'?'上传视频':'修改视频'}}</el-button
          ><span class="file-name">{{ fileName }}</span>
          <el-progress :percentage="progress" v-if="progress"></el-progress>
          <input
            type="file"
            hidden
            ref="video"
            @change="selectVideoFiles"
            accept="video/*"
          />
        </el-form-item>

       
        <el-form-item label-width=40% style="margin-top: 20px;">
           <el-button type="primary" v-if="isAdd=='add'" @click="addNow" >立即添加</el-button>
           <el-button type="primary" v-else @click="editReadNow">立即修改</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    </el-card>
  </div>
</template>

<script>
//引入富文本组件
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
var COS = require("cos-js-sdk-v5");
import {
  CourseList,
  CourseType,
  CourseDel,
  CourseAdd,
  CourseEdit,
  getCourseCosToken,
} from "@/api/Japanese_app/japanese_curriculum.js";
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      queryForm: {
        type: "",
        title: "",
        page: 1,
        limit: 10,
        start_time: null,
        end_time: null,
      },
      courseList: [],
      courseTypeData: [],
      total: 0,
      addDialog: false,
      times: null,
      addForm: {
        type: "",
        title: "",
        thumb: "",
        video: "",
      },
      addtitle: "",
      isAdd: "add",
      fileName: "",
      progress: 0,
      thumbSrc: "",
    };
  },

  created() {
    this.getCourseType();
    this.getCourseList();
  },
  methods: {
    //   日语APP课程类型
    getCourseType() {
      CourseType().then((res) => {
        this.courseTypeData = res.data;
      });
    },
    //   日语APP课程列表
    getCourseList() {
      CourseList(this.queryForm).then((res) => {
        if (res.code !== 1) {
          this.$message.error(res.msg);
          return;
        }
        this.total = res.data.total;
        this.courseList = res.data.data;
      });
    },

    // 删除课程
    async removeTask(id) {
      const result = await this.$confirm("是否要删除该课程?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (result !== "confirm") return this.$message.info("已经取消删除");
      CourseDel({ id: id }).then((res) => {
        if (res.code !== 1) {
          this.$message.error(res.msg);
          return;
        }
        this.$message.success("删除课程成功");
        this.getCourseList();
      });
    },

    // 添加弹窗
    toAdd() {
      this.isAdd = "add";
      this.addtitle = "添加课程";
      this.lineData = [];
      this.addDialog = true;
      this.isCascader = true;
    },
    // 点击选择视频文件按钮
    selectvideo() {
      this.$refs.video.click();
    },

    // 选中视频
    selectVideoFiles(e) {
      let file = this.$refs.video.files[0];
      this.fileName = file.name;
      const isSize = file.size / 1024 / 1024 < 500;
      if (!isSize) {
        this.$message.error("上传视频不能超过 500MB!");
        return;
      }

      let that = this;
      getCourseCosToken({ suffix: file.name }).then((res) => {
        var cos = new COS({
          getAuthorization: function (options, callback) {
            callback({
              TmpSecretId: res.data.credentials.tmpSecretId,
              TmpSecretKey: res.data.credentials.tmpSecretKey,
              XCosSecurityToken: res.data.credentials.sessionToken,
              StartTime: res.data.startTime,
              ExpiredTime: res.data.expiredTime,
              expiration: res.data.expiration,
              requestId: res.data.requestId,
            });
          },
        });
        cos.putObject(
          {
            Bucket: res.data.Bucket,
            Region: res.data.Region,
            Key: res.data.key,
            // ContentType:'multipart/form-data',
            Body: file, // 上传文件对象
            onProgress: function (progressData) {
              that.progress = progressData.percent * 100;
            },
          },
          function (err, data) {
            if (data) {
              that.addForm.video = res.data.key;
            }
            e.target.value = "";
          }
        );
      });
    },

    // 上传缩略图
    beforeThumbUpload(file) {
      const isSize = file.size / 1024 / 1024 < 10;
      if (!isSize) {
        this.$message.error("上传缩略图不能超过 10MB!");
        return;
      }
      let that = this;
      getCourseCosToken({ suffix: file.name }).then((res) => {
        var cos = new COS({
          getAuthorization: function (options, callback) {
            callback({
              TmpSecretId: res.data.credentials.tmpSecretId,
              TmpSecretKey: res.data.credentials.tmpSecretKey,
              XCosSecurityToken: res.data.credentials.sessionToken,
              StartTime: res.data.startTime,
              ExpiredTime: res.data.expiredTime,
              expiration: res.data.expiration,
              requestId: res.data.requestId,
            });
          },
        });
        cos.putObject(
          {
            Bucket: res.data.Bucket,
            Region: res.data.Region,
            Key: res.data.key,
            // ContentType:'multipart/form-data',
            Body: file, // 上传文件对象
            onProgress: function (progressData) {},
          },
          function (err, data) {
            if (data) {
              that.addForm.thumb = res.data.key;
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = (e) => {
                that.thumbSrc = e.target["result"]; // 获取文件装换后的Base64位文件
                that.$forceUpdate();
              };
            }
          }
        );
      });
    },

    // 添加课程
    addNow() {
      if (this.addForm.type == "") {
        this.$message.error("请选择分类");
        return;
      } else if (this.addForm.title == "") {
        this.$message.error("请输入标题");
        return;
      } else if (this.addForm.thumb == "") {
        this.$message.error("请选择封面图");
        return;
      } else if (this.addForm.video == "") {
        this.$message.error("请上传视频");
        return;
      }
      CourseAdd(this.addForm).then((res) => {
        if (res.code !== 1) {
          this.$message.error(res.msg);
          return;
        }
        this.$message.success("添加课程成功");
        this.addDialog = false;
        this.getCourseList();
      });
    },

    // 点击编辑图标
    editGoods(item) {
      this.isAdd = "edit";
      this.addtitle = "编辑课程";
      this.addDialog = true;
      this.addForm = JSON.parse(JSON.stringify(item));
      this.thumbSrc = this.addForm.thumb_url;
    },

    // 点击立即修改
    editReadNow() {
      if (this.addForm.type == "") {
        this.$message.error("请选择分类");
        return;
      } else if (this.addForm.title == "") {
        this.$message.error("请输入标题");
        return;
      } else if (this.addForm.thumb == "") {
        this.$message.error("请选择封面图");
        return;
      } else if (this.addForm.video == "") {
        this.$message.error("请上传视频");
        return;
      }
      CourseEdit(this.addForm).then((res) => {
        if (res.code !== 1) {
          this.$message.error(res.msg);
          return;
        }
        this.$message.success("修改课程成功");
        this.addDialog = false;
        this.getCourseList();
      });
    },

    // 弹窗关闭事件
    closed() {
      this.addForm = {
        type: "",
        title: "",
        thumb: "",
        video: "",
      };
      this.thumbSrc = "";
      this.fileName = "";
      this.progress = 0;

      if (this.$refs.videoPlay !== undefined) {
        this.$refs.videoPlay.pause();
      }
    },

    //  查询
    toQuery() {
      this.queryForm.page = 1;
      if (this.times) {
        this.queryForm.start_time = new Date(this.times[0]).getTime() / 1000;
        this.queryForm.end_time = new Date(this.times[1]).getTime() / 1000;
      } else if (this.times == null) {
        this.queryForm.start_time = null;
        this.queryForm.end_time = null;
      }
      this.getCourseList();
    },
    handleSizeChange(size) {
      this.queryForm.limit = size;
      this.getCourseList();
    },
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getCourseList();
    },
  },
};
</script>

<style scoped lang="less">
.generate {
  float: right;
}
.el-tag {
  cursor: pointer;
}
::v-deep .ql-editor {
  min-height: 400px;
}
.thumb_box {
  width: 200px;
  height: 120px;
  img {
    width: 100%;
    height: 100%;
  }
}

.video_box {
  width: 100%;
  height: 300px;
  margin-bottom: 10px;
  video {
    width: 100%;
    height: 100%;
  }
}
</style>
